// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"cq-z","slideIn":"dq-z"};